/* eslint-disable */
export default {
  region: '지역',
  calling: '통화',
  logout: '로그아웃',
  version: '버전',
  settings: '설정',
  selectToDialSMS: '전화 걸기/SMS 보내기 선택',
  selectToDial: '전화 걸기 선택',
  selectToSMS: 'SMS 보내기 선택',
  clickToDial: '클릭하여 통화',
  autoCreateLog: '통화 기록 자동으로 만들기',
  autoCreateSMSLog: 'SMS 기록 자동으로 만들기',
  autoLogCalls: '통화 자동 기록',
  autoLogNotes: '메모 자동 기록',
  autoLogSMS: 'SMS 자동 기록',
  clickToSMS: '클릭하여 SMS 보내기',
  logSMSContent: 'SMS 콘텐츠 기록',
  clickToDialSMS: '클릭하여 통화/SMS 보내기',
  logExtensionCall: '내선 통화 기록',
  audio: '오디오',
  language: '언어',
  feedback: '피드백',
  userGuide: '새로운 기능',
  quickAccess: '빠른 액세스 설정',
  report: '분석 보고서',
  shareIdea: '아이디어 공유',
  openEntityFrom: 'Salesforce 개체 동작',
  ctiPanelSize: 'CTI 패널 크기',
  openInNewTab: '새 탭에서 열기',
  openInCurrentTab: '현재 탭에서 열기',
  reportIssue: '문제 신고',
  contactSupport: '지원팀에 문의',
  selectToDialHint:
    '더 나은 경험을 위해 대량 전화번호 페이지에서 RingCentral로 전화를 걸 전화번호를 선택하세요.',
} as const;

// @key: @#@"region"@#@ @source: @#@"Region"@#@
// @key: @#@"calling"@#@ @source: @#@"Calling"@#@
// @key: @#@"logout"@#@ @source: @#@"Logout"@#@
// @key: @#@"version"@#@ @source: @#@"Version"@#@
// @key: @#@"settings"@#@ @source: @#@"Settings"@#@
// @key: @#@"selectToDialSMS"@#@ @source: @#@"Select to Dial/SMS"@#@
// @key: @#@"selectToDial"@#@ @source: @#@"Select to Dial"@#@
// @key: @#@"selectToSMS"@#@ @source: @#@"Select to SMS"@#@
// @key: @#@"clickToDial"@#@ @source: @#@"Click to Dial"@#@
// @key: @#@"autoCreateLog"@#@ @source: @#@"Auto-create Call Log"@#@
// @key: @#@"autoCreateSMSLog"@#@ @source: @#@"Auto-create SMS Log"@#@
// @key: @#@"autoLogCalls"@#@ @source: @#@"Auto log calls"@#@
// @key: @#@"autoLogNotes"@#@ @source: @#@"Auto log notes"@#@
// @key: @#@"autoLogSMS"@#@ @source: @#@"Auto log SMS"@#@
// @key: @#@"clickToSMS"@#@ @source: @#@"Click to SMS"@#@
// @key: @#@"logSMSContent"@#@ @source: @#@"Log SMS content"@#@
// @key: @#@"clickToDialSMS"@#@ @source: @#@"Click to Dial/SMS"@#@
// @key: @#@"logExtensionCall"@#@ @source: @#@"Log extension calls"@#@
// @key: @#@"audio"@#@ @source: @#@"Audio"@#@
// @key: @#@"language"@#@ @source: @#@"Language"@#@
// @key: @#@"feedback"@#@ @source: @#@"Feedback"@#@
// @key: @#@"userGuide"@#@ @source: @#@"What's New"@#@
// @key: @#@"quickAccess"@#@ @source: @#@"Quick Access Setting"@#@
// @key: @#@"report"@#@ @source: @#@"Analytics Report"@#@
// @key: @#@"shareIdea"@#@ @source: @#@"Share idea"@#@
// @key: @#@"openEntityFrom"@#@ @source: @#@"Salesforce object behavior"@#@
// @key: @#@"ctiPanelSize"@#@ @source: @#@"CTI panel size"@#@
// @key: @#@"openInNewTab"@#@ @source: @#@"Open in new tab"@#@
// @key: @#@"openInCurrentTab"@#@ @source: @#@"Open in current tab"@#@
// @key: @#@"reportIssue"@#@ @source: @#@"Report issue"@#@
// @key: @#@"contactSupport"@#@ @source: @#@"Contact support"@#@
// @key: @#@"selectToDialHint"@#@ @source: @#@"For your better experience, select phone number to dial with RingCentral in large quantity phone number page."@#@
